import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ConnectorInterface } from '@interface/connector/connector.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialConnectorsState } from './connectors.initial-state';

export const connectorsSlice = createSlice({
  name: 'connectors',
  initialState: initialConnectorsState,
  reducers: {
    ...baseReducerActions(initialConnectorsState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<ConnectorInterface[]>>) => {
      state.data = mapifyPayload(payload?.data ?? [], 'serviceId');
    },
  },
});

export const connectorsActions = connectorsSlice.actions;
